module.exports = __webpack_public_path__ + "static/media/red-map-pin.f6587731.svg";